import React from 'react';

interface SectionProps {
  id: string;
  title?: string;
  subtitle?: string;
  className?: string;
  children: React.ReactNode;
  dark?: boolean;
}

export const Section: React.FC<SectionProps> = ({ id, title, subtitle, className = '', children, dark = false }) => {
  return (
    <section 
      id={id} 
      className={`
        relative w-full py-20 px-6 md:px-12 lg:px-24 scroll-mt-20
        ${dark ? 'bg-salt-slate/5 text-white' : 'bg-transparent text-salt-charcoal'}
        ${className}
      `}
    >
      <div className="max-w-6xl mx-auto">
        {(title || subtitle) && (
          <div className="mb-12 md:mb-16">
            {subtitle && (
              <span className="block font-roboto text-salt-teal font-bold tracking-[2px] uppercase text-sm mb-2">
                {subtitle}
              </span>
            )}
            {title && (
              <h2 className="font-oswald text-4xl md:text-5xl font-medium tracking-tight text-salt-charcoal">
                {title}
              </h2>
            )}
            <div className="w-20 h-1 bg-salt-teal mt-6 rounded-full" />
          </div>
        )}
        {children}
      </div>
    </section>
  );
};